import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { Bom, BomMaterial, BomProduct, Product, ProductType } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-products-boms-edit',
    templateUrl: './products-boms-edit.component.html',
    styleUrls: ['./products-boms-edit.component.sass'],
    standalone: false
})
export class ProductsBomsEditComponent extends GenericCrudEditComponent<Bom> {
  @Input() product: Product
  productTypes = ProductType
  bomProducts: BomProduct[]
  bomMaterials: BomMaterial[]

  constructor() {
    super()
    this.resource = this.api.resources.product.boms;
    this.product = {} as Product;
    this.bomProducts = [];
    this.bomMaterials = [];

    this.productTypes.forEach(x => x.displayName = this.translationService.instant(`enumeration.ProductType.${x.name}`));
  }

  initFormGroup(): FormGroup {
    const group = this.fb.group({
      id: [this.entity!.id],
      code: this.product.code,
      name: this.product.name,
      version: [this.entity!.version]
    });
    return group;
  }

  protected override async preFetch(): Promise<void> {
    await this.getBomProducts();
    await this.getBomMaterials();
    await this.fillRelatedProducts();
  }



  async fillRelatedProducts(): Promise<void> {

    for (let index = 0; index < this.bomProducts.length; index++) {
      const element = this.bomProducts[index];
      const rs = await firstValueFrom(this.api.resources.product.products.get(element.productId));
      if (rs){
        element.product = rs;
      }      
    }

    for (let index = 0; index < this.bomMaterials.length; index++) {
      const element = this.bomMaterials[index];
      const rs = await firstValueFrom(this.api.resources.product.products.get(element.productId));
      if (rs){
        element.product = rs;
      }      
    }
    
  }

  async getBomProducts(): Promise<void> {
    const productsByBomId: any = await firstValueFrom(this.api.getBomProductsByBomId(this.entity!.id));
    this.bomProducts = productsByBomId;
  }

  async getBomMaterials(): Promise<void> {
    const materialsByBomId: any = await firstValueFrom(this.api.getBomMaterialsByBomId(this.entity!.id));
    this.bomMaterials = materialsByBomId;
  }

  displayEntity(): string {
    return this.entity!.goodId?.toString() ?? '';
  }
}
